import React from 'react'
import BusinessPage from './components/BusinessPage'

const RefundPolicy = () => {
    return (
        <BusinessPage title={"Refund Policy"}>
            <p><strong>Refund Policy for Bento Delivaz Buyer App</strong></p>

<p><strong>Effective Date:</strong> 22 July 2022</p>

<p>At Bento Delivaz Logistics Limited (&ldquo;Bento Delivaz&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;), we strive to provide our customers with the best possible service and high-quality food delivery experience. However, we understand that issues may arise, and we are committed to resolving them promptly and fairly. This refund policy outlines the conditions under which refunds will be granted and the process for requesting a refund.</p>

<p><strong>1. Refund Eligibility</strong></p>

<p>1.1 <strong>Order Issues:</strong> Refunds will be considered under the following circumstances:</p>

<ul>
	<li>Incorrect order: If you receive an order that is incorrect, including wrong items or missing items.</li>
	<li>Poor quality: If the food received is spoiled, contaminated, or otherwise of unacceptable quality.</li>
	<li>Non-delivery: If your order is not delivered within the estimated delivery time and no acceptable resolution is provided.</li>
</ul>

<p>1.2 <strong>Order Cancellation:</strong> You may cancel your order within a specified time frame to be eligible for a refund. Refunds for canceled orders will be processed as follows:</p>

<ul>
	<li><strong>Before Acceptance:</strong> If you cancel your order before the restaurant accepts it, you will receive a full refund.</li>
	<li><strong>After Acceptance:</strong> If you cancel your order after the restaurant accepts it, a partial refund may be granted at the discretion of Bento Delivaz, depending on the preparation status of the order.</li>
</ul>

<p>1.3 <strong>Payment Errors:</strong> If you are charged incorrectly due to a technical error or payment processing issue, you will be eligible for a refund of the overcharged amount.</p>

<p><strong>2. Refund Process</strong></p>

<p>2.1 <strong>Requesting a Refund:</strong> To request a refund, please contact our customer support team within 24 hours of receiving your order. You can reach us via the chat feature in the mobile application or email us at refunds@bentodelivaz.com. Provide your order details, the reason for the refund request, and any supporting evidence, such as photos of incorrect or poor-quality items.</p>

<p>2.2 <strong>Refund Review:</strong> Our customer support team will review your refund request and may contact you for additional information or clarification. We aim to resolve all refund requests within 5-7 business days.</p>

<p>2.3 <strong>Refund Approval:</strong> If your refund request is approved, the refund will be processed using the original payment method. Depending on your payment provider, it may take an additional 5-10 business days for the refund to appear in your account.</p>

<p><strong>3. Non-Refundable Situations</strong></p>

<p>Refunds will not be granted under the following circumstances:</p>

<ul>
	<li>Change of mind: If you change your mind after placing an order and the restaurant has already accepted or started preparing it.</li>
	<li>Incorrect address: If the delivery address provided is incorrect or incomplete, resulting in failed delivery.</li>
	<li>Unavailability: If you are unavailable to receive the order at the designated delivery location and time.</li>
	<li>Tampered orders: If the food has been tampered with or altered in any way after delivery.</li>
</ul>

<p><strong>4. Partial Refunds</strong></p>

<p>In some cases, partial refunds may be issued instead of a full refund. This may occur if only part of the order is incorrect or of poor quality. The amount of the partial refund will be determined based on the value of the affected items.</p>

<p><strong>5. Dispute Resolution</strong></p>

<p>If you are not satisfied with the outcome of your refund request, you may escalate the issue to our customer support manager for further review. Our goal is to ensure that all disputes are resolved fairly and to your satisfaction.</p>

<p><strong>6. Contact Us</strong></p>

<p>If you have any questions or need further assistance with our refund policy, please contact our customer support team at:</p>

<p><strong>Bento Delivaz Limited</strong><br />
Email: refunds@bentodelivaz.com<br />
Customer Support: 09070059320</p>

<p>Thank you for choosing Bento Delivaz. We apgetpreciate your trust in our services and are committed to providing you with the best possible experience.</p>

<p><strong>Note:</strong> This refund policy is subject to change without notice. Please review it periodically to stay informed of any updates.</p>

        </BusinessPage>
    )
}

export default RefundPolicy